/* eslint-disable no-mixed-operators */
import * as React from 'react';
import Helper from '../../../core/libraries/Helper';
import { connect } from 'react-redux';
import Color from '../../../core/libraries/Color';
import Template from '../../../core/libraries/Template';
import _ from 'lodash';
import { getReportDispatch, getDocumentTypesDispatch } from '../thunks';
import { showDialog, showToastMessage, confirmDialog } from '../../Dialog/actions';
import Constants from '../../../core/libraries/Constants';
import RbLabel, { LabelSize } from '../../../bosch-react/components/label/RbLabel';
import RbButton, { ButtonSize, ButtonType } from '../../../bosch-react/components/button/RbButton';
import RbTextField from '../../../bosch-react/components/text-field/RbTextField';
import { MessageBar, MessageBarType } from '@fluentui/react';
import { RootState } from '../../../store/store';
import { init, updateProperty, validateData } from '../actions';
import { IUserProfile } from '../../Auth/types';
import { checkAllowRequestorManagerFallback, initOrder, order } from '../services';
import { LoadingBasicDialog } from '../../../core/components/LoadingDialog';
import { ILowerFirstCaseMetadata } from '../types';
import { IOrderedStatistic, StatisticType, insertStatisticData } from '../../Statistics/services';

interface OrderProps {
    userProfile: IUserProfile | undefined,
    reportId: any,
    validation: any,
    init: typeof init,
    getReportDispatch: any,
    getDocumentTypesDispatch: any,
    updateProperty: typeof updateProperty,
    validateData: typeof validateData,
    showDialog: typeof showDialog,
    confirmDialog: typeof confirmDialog,
    showToastMessage: typeof showToastMessage,
    history: any,
}

interface IState {
    guid: string,
    orderInfo: ILowerFirstCaseMetadata | undefined,
    isLoading: boolean,
    allowRequestorManagerFallback?: boolean,
}

class Order extends React.Component<OrderProps, IState> {
    private commentRef: React.RefObject<any> = React.createRef();

    constructor(props: OrderProps) {
        super(props);
        this.state = {
            guid: "",
            orderInfo: undefined,
            isLoading: true,
            allowRequestorManagerFallback: undefined,
        };
        this.renderTitle = this.renderTitle.bind(this);
        this.renderAuthors = this.renderAuthors.bind(this);
        this.renderDepartment = this.renderDepartment.bind(this);
        this.renderApprovers = this.renderApprovers.bind(this);
        this.renderPortfolioApprover = this.renderPortfolioApprover.bind(this);
        this.renderReportDate = this.renderReportDate.bind(this);
        this.renderKeywords = this.renderKeywords.bind(this);
        this.renderRelaventForeinTradeLegislation = this.renderRelaventForeinTradeLegislation.bind(this);
        this.renderAbstract = this.renderAbstract.bind(this);
        this.renderReportType = this.renderReportType.bind(this);
        this.renderReason = this.renderReason.bind(this);
        this.renderButtons = this.renderButtons.bind(this);
        this.renderError = this.renderError.bind(this);
        this.orderReport = this.orderReport.bind(this);
        this.cancelChanges = this.cancelChanges.bind(this);
    }

    async componentDidMount(): Promise<void> {
        try {
            const callInitOrder = await initOrder(this.props.reportId);
            const allowRequestorManagerFallback = await checkAllowRequestorManagerFallback();
            this.setState({
                orderInfo: callInitOrder,
                allowRequestorManagerFallback: allowRequestorManagerFallback,
            })
            this.setState({
                isLoading: false
            })
        } catch (error: any) {
            if (error.message && error.message.includes("already requested permission for this document")) {
                this.props.history.push(process.env.REACT_APP_ALREADY_REQUESTED);
            } else {
                this.setState({
                    isLoading: false
                })
                // Handle other errors as needed
                console.error("Error in componentDidMount:", error);
            }
        }
    }

    render() {
        return (
            // eslint-disable-next-line no-mixed-operators
            !!this.state.isLoading && <LoadingBasicDialog dialogMessage='Retrieve order information...'></LoadingBasicDialog> || <div className="ms-Grid">
                {this.renderError()}
                <div className="ms-Grid-row">
                    <RbLabel style={{ color: Color.BLUE }}><h2 style={{ margin: "0px" }}>Order Report</h2></RbLabel>
                </div>
                {(!_.isNil(this.state.orderInfo)) && <div className="ms-Grid-row">
                    {this.renderTitle()}
                    {this.renderAuthors()}
                    {this.renderDepartment()}
                    {this.renderApprovers()}
                    {this.renderPortfolioApprover()}
                    {this.renderReportDate()}
                    {this.renderKeywords()}
                    {this.state.orderInfo.uploadType === "RnD" ? this.renderRelaventForeinTradeLegislation() : null}
                    {this.renderAbstract()}
                    {this.renderReportType()}
                    {this.renderReason()}
                    {this.renderButtons()}
                </div>}
            </div>

        );
    }

    renderTitle() {
        return (
            <div className="ms-Grid">
                <div className="ms-Grid-row common-padding-row">
                    <div className="ms-Grid-col ms-sm3"><RbLabel style={{ fontSize: "16px" }}>Title</RbLabel></div>
                    <div className="ms-Grid-col ms-sm6">
                        <span className="textarea-transparent">
                            {/* <TextareaAutosize style={{ overflowX: "hidden" }} minRows={1} maxRows={8} defaultValue={this.state.orderInfo.Title} disabled={true} /> */}
                            <RbLabel isMultipleLines={true} maxLines={8}>{this.state.orderInfo?.title}</RbLabel>
                        </span>
                    </div>
                    <div className="ms-Grid-col ms-sm3"></div>
                </div>
            </div>
        );
    }

    renderAuthors() {
        return (
            <div className="ms-Grid">
                <div className="ms-Grid-row common-padding-row">
                    <div className="ms-Grid-col ms-sm3"><RbLabel style={{ fontSize: "16px" }}>Author(s)</RbLabel></div>
                    <div className="ms-Grid-col ms-sm6">
                        {!!this.state.orderInfo?.authors && Template.renderReadOnlyPeople(this.state.orderInfo?.authors, this.state.orderInfo?.authorDisplayName)}
                    </div>
                    <div className="ms-Grid-col ms-sm3"></div>
                </div>
            </div>
        );
    }

    renderDepartment() {
        return (
            <div className="ms-Grid">
                <div className="ms-Grid-row common-padding-row">
                    <div className="ms-Grid-col ms-sm3"><RbLabel style={{ fontSize: "16px" }}>Department</RbLabel></div>
                    <div className="ms-Grid-col ms-sm6">
                        <span className="textarea-transparent">
                            {/* <TextareaAutosize style={{ overflowX: "hidden" }} minRows={1} maxRows={8} defaultValue={this.state.orderInfo.FeberDepartment} disabled={true} /> */}
                            <RbLabel maxLines={8}>{this.state.orderInfo?.department}</RbLabel>
                        </span>
                    </div>
                    <div className="ms-Grid-col ms-sm3"></div>
                </div>
            </div>
        );
    }

    renderApprovers() {
        return (
            <>
                <div className="ms-Grid">
                    <div className="ms-Grid-row common-padding-row">
                        <div className="ms-Grid-col ms-sm3"><RbLabel style={{ fontSize: "16px" }}>Responsible for Requestor</RbLabel></div>
                        <div className="ms-Grid-col ms-sm6">
                            <span className="textarea-transparent">
                                {!!this.state.orderInfo?.rou && Template.renderReadOnlyPeople([this.state.orderInfo?.rou])}
                            </span>
                        </div>
                        <div className="ms-Grid-col ms-sm3"></div>
                    </div>

                </div>
                <div className="ms-Grid">
                    <div className="ms-Grid-row common-padding-row">
                        <div className="ms-Grid-col ms-sm3"><RbLabel style={{ fontSize: "16px" }}>Responsible for Report</RbLabel></div>
                        <div className="ms-Grid-col ms-sm6">
                            <span className="textarea-transparent">
                                {!!this.state.orderInfo?.rfd && Template.renderReadOnlyPeople([this.state.orderInfo?.rfd])}
                            </span>
                        </div>
                        <div className="ms-Grid-col ms-sm3"></div>
                    </div>
                </div>
            </>
        );
    }

    renderPortfolioApprover() {
        if (this.state.orderInfo?.uploadType === "RnD" && this.state.orderInfo?.division === "CR") {
            return (
                <div className="ms-Grid">
                    <div className="ms-Grid-row common-padding-row">
                        <div className="ms-Grid-col ms-sm3"><RbLabel style={{ fontSize: "16px" }}>Strategic Portfolio Owner</RbLabel></div>
                        <div className="ms-Grid-col ms-sm6">
                            <span className="textarea-transparent">
                                {Template.renderReadOnlyPeoplePickerTags(Helper.getPeoplePickerStringByObjectArray([this.state.orderInfo?.rou]))}
                            </span>
                        </div>
                        <div className="ms-Grid-col ms-sm3"></div>
                    </div>
                </div>
            );
        }
        else {
            return null;
        }
    }

    renderReportDate() {
        return (
            <div className="ms-Grid">
                <div className="ms-Grid-row common-padding-row">
                    <div className="ms-Grid-col ms-sm3"><RbLabel style={{ fontSize: "16px" }}>Report date</RbLabel></div>
                    <div className="ms-Grid-col ms-sm6"><RbLabel>{Helper.getDateTimeFormatForUI(this.state.orderInfo?.documentDate)}</RbLabel></div>
                    <div className="ms-Grid-col ms-sm3"></div>
                </div>
            </div>
        );
    }

    renderKeywords() {
        return (
            <div className="ms-Grid">
                <div className="ms-Grid-row common-padding-row">
                    <div className="ms-Grid-col ms-sm3"><RbLabel style={{ fontSize: "16px" }}>Keywords</RbLabel></div>
                    <div className="ms-Grid-col ms-sm6">
                        <span className="textarea-transparent">
                            {/* <TextareaAutosize style={{ overflowX: "hidden" }} minRows={1} maxRows={8} defaultValue={this.state.orderInfo?.Keywords} disabled={true} /> */}
                            <RbLabel isMultipleLines={true} maxLines={8}>{this.state.orderInfo?.keywords}</RbLabel>
                        </span>
                    </div>
                    <div className="ms-Grid-col ms-sm3"></div>
                </div>
            </div>
        );
    }

    renderRelaventForeinTradeLegislation() {
        return (
            <div className="ms-Grid">
                <div className="ms-Grid-row common-padding-row">
                    <div className="ms-Grid-col ms-sm3"><RbLabel style={{ fontSize: "16px" }}>Report contains export controlled material</RbLabel></div>
                    <div className="ms-Grid-col ms-sm6">
                        <span className="textarea-transparent">
                            <RbLabel isMultipleLines={true} maxLines={8}>{this.state.orderInfo?.relForForeignTradeLegislation ? "Yes" : "No"}</RbLabel>
                        </span>
                    </div>
                    <div className="ms-Grid-col ms-sm3"></div>
                </div>
            </div>
        );
    }

    renderAbstract() {
        return (
            <div className="ms-Grid">
                <div className="ms-Grid-row common-padding-row">
                    <div className="ms-Grid-col ms-sm3"><RbLabel style={{ fontSize: "16px" }}>Abstract</RbLabel></div>
                    <div className="ms-Grid-col ms-sm6">
                        <span className="textarea-transparent">
                            {/* <TextareaAutosize style={{ overflowX: "hidden" }} minRows={1} maxRows={8} defaultValue={this.state.orderInfo?.Abstract} disabled={true} /> */}
                            <RbLabel isMultipleLines={true} maxLines={8}>{this.state.orderInfo?.abstract}</RbLabel>
                        </span>
                    </div>
                    <div className="ms-Grid-col ms-sm3"></div>
                </div>
            </div>
        );
    }

    renderReportType() {
        return (
            <div className="ms-Grid">
                <div className="ms-Grid-row common-padding-row">
                    <div className="ms-Grid-col ms-sm3"><RbLabel style={{ fontSize: "16px" }}>Report type</RbLabel></div>
                    <div className="ms-Grid-col ms-sm6">
                        <span className="textarea-transparent">
                            {/* <TextareaAutosize style={{ overflowX: "hidden" }} minRows={1} maxRows={8} defaultValue={this.state.orderInfo?.DocumentType} disabled={true} /> */}
                            <RbLabel>{this.state.orderInfo?.documentType}</RbLabel>
                        </span>
                    </div>
                    <div className="ms-Grid-col ms-sm3"></div>
                </div>
            </div>
        );
    }

    handleCommentChange = () => {
        let currentValue = this.commentRef.current.getValue();
        this.setState({
            orderInfo: { ...this.state.orderInfo, comment: currentValue }
        })
    }

    isValidForm = () => {
        let { rou, rfd, comment } = this.state.orderInfo!;
        if (this.state.allowRequestorManagerFallback) {
            // If fallback is allowed, only rou and comment are required
            return !!rou && !!comment;
        } else {
            // If fallback is not allowed, all three are required
            return !!rou && !!rfd && !!comment;
        }
    }

    renderReason() {
        return (
            <div className="ms-Grid">
                <div className="ms-Grid-row common-padding-row">
                    <div className="ms-Grid-col ms-sm3"><RbLabel style={{ fontSize: "16px" }}>Tell the Approver why you need this report? <span style={{ color: "red" }}>*</span></RbLabel></div>
                    <div className="ms-Grid-col ms-sm6">
                        <RbTextField ref={this.commentRef} value={this.state.orderInfo?.comment} minRows={4} onChange={() => this.handleCommentChange()} />
                        {!!this.state.orderInfo?.comment ? null : <RbLabel className="error-txt" size={LabelSize.Small} isInline={false}> Please provide a reason for requesting this report. </RbLabel>}

                    </div>
                    <div className="ms-Grid-col ms-sm3"></div>
                </div>
            </div>
        );
    }

    renderButtons() {
        return (
            <div className="ms-Grid">
                <div className="ms-Grid-row common-padding-row">
                    <RbButton label="Request" size={ButtonSize.Small} onClick={this.orderReport} disabled={this.isValidForm() === false} />
                    <RbButton type={ButtonType.Secondary} size={ButtonSize.Small} label="Cancel" onClick={this.cancelChanges} />
                </div>
            </div>
        );
    }

    renderError() {
        let { rfd, rou } = this.state.orderInfo!
        const hasErrors = (!!!rfd && !this.state.allowRequestorManagerFallback) || !!!rou;

        if (!hasErrors) return null;

        return (
            <div className="ms-Grid">
                {!!!rfd && !this.state.allowRequestorManagerFallback && (
                    <div className="ms-Grid-row common-padding-row">
                        <MessageBar messageBarType={MessageBarType.error}>
                            Responsible for document not found.
                        </MessageBar>
                    </div>
                )}
                {!!!rou && (
                    <div className="ms-Grid-row common-padding-row">
                        <MessageBar messageBarType={MessageBarType.error}>
                            Your Head of Department (HoD) not found.
                        </MessageBar>
                    </div>
                )}
                <div className="ms-Grid-row common-padding-row">
                    <MessageBar messageBarType={MessageBarType.info}>
                        Please click the Support button located below your avatar for assistance to proceed with your request.
                    </MessageBar>
                </div>
            </div>
        );
    }

    orderReport() {
        !!this.isValidForm() && this.props.showDialog("Creating order") && order(this.state.orderInfo).then((rs: any) => {
            this.props.showDialog(false);
            !!rs && Helper.runNewTask(async () => {
                let orderedData: IOrderedStatistic = {
                    reportGuid: this.state.orderInfo?.guid || "",
                    createdBy: this.props.userProfile?.name || "",
                    department: this.props.userProfile?.department || "",
                    division: this.props.userProfile?.division || "",
                    orderId: rs,
                }
                await insertStatisticData(StatisticType.Ordered, orderedData)
            })
            this.props.confirmDialog(Constants.REPORT_MESSAGE.ORDER.TITLE,
                ((!!rs) ? Constants.REPORT_MESSAGE.ORDER.SUCCESS : Constants.REPORT_MESSAGE.ORDER.FAILED).replace("{0}", this.state.orderInfo?.title || "")
                , true, () => {
                    this.props.history.push(process.env.REACT_APP_MY_PENDING_ORDERS)
                });
        });
    }

    cancelChanges() {
        window.close();
    }
}

const mapStateToProps = (state: RootState) => ({
    userProfile: state.auth.userProfile,
    report: state.accessMediator.report,
    error: state.accessMediator.error,
    validation: state.accessMediator.validation
});

export default connect(mapStateToProps, {
    init,
    getReportDispatch,
    getDocumentTypesDispatch,
    updateProperty,
    validateData,
    showDialog,
    confirmDialog,
    showToastMessage
})(Order);